import React from 'react';
import { useHistory } from 'react-router-dom';
import IconLink from '../Menus/IconLink';
import { Tool, UserCheck, Database, Save, TrendingUp, List, Columns } from 'react-feather';
import SideBarWrapper, { SideBarIconGroup } from './SideBarWrapper';
import "./SideBarRight.scss";

const SideBarRight = ({ location, setSideBarExtRight, sideBarExtRight, isExternalManager, compareLink }) => {
	const history = useHistory();
	const checkRoute = (route) => {
		return route === "/" ? location.pathname === route : location.pathname.startsWith(route)
	}

	return (
		<SideBarWrapper borderLeft right>
			<SideBarIconGroup>
				<IconLink
					icon={<UserCheck />}
					onClick={() => {
						setSideBarExtRight("Comments", true)
					}}
					active={sideBarExtRight === "Comments"}
					disabled={isExternalManager}
				/>
				<IconLink
					icon={<Tool />}
					onClick={() => {
						setSideBarExtRight("Options", true)
					}}
					active={sideBarExtRight === "Options"}
					label="Options"
					disabled={isExternalManager}
				/>
				<IconLink
					icon={<i className='material-icons'>format_list_bulleted_add</i>}
					onClick={() => {
						setSideBarExtRight("Notes", true)
					}}
					active={sideBarExtRight === "Notes"}
					label="Notes"
					disabled={isExternalManager}
				/>
				<IconLink
					icon={<Save />}
					onClick={() => {
						setSideBarExtRight("Versions", true)
					}}
					active={sideBarExtRight === "Versions"}
					label="History"
				/>
				{/* Hidden (not just disabled) for external managers — compare is an
				    internal review tool (RES-561 follow-up item 1). Equivalent to
				    versionApi.canUseCompare here: the editor is only reachable with
				    EDIT or EXTERNAL_EDITOR, so !isExternalManager ⇒ has EDIT. If the
				    policy changes there, revisit this gate. */}
				{!isExternalManager && (
					<IconLink
						icon={<Columns />}
						onClick={() => {
							if (compareLink) history.push(compareLink)
						}}
						label="Compare"
						disabled={!compareLink}
					/>
				)}
				<IconLink
					icon={<Database />}
					onClick={() => {
						setSideBarExtRight("Data", true)
					}}
					active={sideBarExtRight === "Data"}
					label="Data"
					disabled={isExternalManager}
				/>
				{/* <IconLink
					icon={<List />}
					onClick={() => {
						setSideBarExtRight("Model", true)
					}}
					active={sideBarExtRight === "Model"}
					label="Model"
				/> */}
			</SideBarIconGroup>
		</SideBarWrapper>
	)
};
export default SideBarRight;